const menuItems = {
  items: [
    {
      id: 'administrative',
      title: 'Administrative',
      type: 'group',
      icon: 'fa fa-pen',
      color: 'brown',
      children: [
        {
          id: 'adm-dashboard',
          title: 'Dashboard',
          type: 'item',
          url: '/hospital/hosp-dashboard',
          icon: 'fas fa-chart-line',
        },
        {
          id: 'adm-patient',
          title: 'Patient',
          type: 'item',
          url: '/hospital/hosp-patient',
          icon: 'fa fa-user',
        },
        {
          id: 'adm-ward',
          title: 'Ward View',
          type: 'item',
          url: '/hospital/hosp-ward',
          icon: 'fa fa-hospital-alt',
        },
        {
          id: 'adm-bed',
          title: 'Bed Calendar View',
          type: 'item',
          url: '/hospital/hosp-bed',
          icon: 'fa fa-bed',
        },
        {
          id: 'birth-record',
          title: 'Birth Record',
          type: 'item',
          url: '/hospital/hosp-birth-record',
          icon: 'fa fa-baby',
        },
        {
          id: 'death-record',
          title: 'Death Record',
          type: 'item',
          url: '/hospital/hosp-death-record',
          icon: 'fa fa-skull',
        },
        {
          id: 'adm-queue',
          title: 'Queue',
          type: 'collapse',
          icon: 'fa fa-sort-numeric-down',
          children: [
            {
              id: 'queue-dashboard',
              title: 'Dashboard',
              type: 'item',
              url: '/hospital/hosp-queue-dashboard',
            },
            {
              id: 'queue-discharge',
              title: 'Discharge',
              type: 'item',
              url: '/hospital/hosp-queue-discharge',
            },
            {
              id: 'queue-call',
              title: 'Call',
              type: 'item',
              url: '/hospital/hosp-queue-call',
            },
          ],
        },
        {
          id: 'adm-appointment',
          title: 'Appointment',
          type: 'collapse',
          icon: 'fa fa-calendar-check',
          children: [
            {
              id: 'appointment-dashboard',
              title: 'Dashboard',
              type: 'item',
              url: '/hospital/hosp-appointment',
            },
            {
              id: 'appointment-calendar',
              title: 'Calendar',
              type: 'item',
              url: '/hospital/hosp-appointment-calendar',
            },
          ],
        },
        {
          id: 'Report Dashboard',
          title: 'Report Dashboard',
          type: 'item',
          url: '/hospital/hosp-report',
          icon: 'fa fa-file-alt',
        },
      
        {
          id: 'Report Category',
          title: 'Category',
          type: 'item',
          url: '/hospital/ReportCategory',
          icon: 'fa fa-file-alt',
        },
        {
          id: 'reportDesign',
          title: 'Export Designer',
          type: 'item',
          url: '/hospital/export-design-dasboard',
          icon: 'fa fa-file-alt',
        },     
        {
          id: 'ExportData',
          title: 'Export Data',
          type: 'item',
          url: '/hospital/Export-data',
          icon: 'fa fa-file-alt',
        },
        {
          id: 'chat',
          title: 'Chat',
          type: 'item',
          url: '/hospital/hosp-chat',
          icon: 'fa fa-comments',
        },
        {
          id: 'borrow-file',
          title: 'Borrow File',
          type: 'item',
          url: '/hospital/hosp-borrow',
          icon: 'fa fa-hand-holding',
        },
      ],
    },
    {
      id: 'department',
      title: 'Department',
      type: 'group',
      icon: 'fa fa-hospital',
      color: '#2ed8b6',
      children: [
        {
          id: 'hosp-laboratory',
          title: 'Laboratory',
          type: 'collapse',
          icon: 'ckd-icon ckd-lab',
          children: [
            {
              id: 'hosp-laboratory-request',
              title: 'Request',
              type: 'item',
              url: '/hospital/hosp-laboratory',
            },
            {
              id: 'hosp-laboratory-result',
              title: 'Result',
              type: 'item',
              url: '/hospital/hosp-lab-result',
            },
            {
              id: 'hosp-laboratory-case',
              title: 'Case',
              type: 'item',
              url: '/hospital/hosp-lab-case',
            },
          ],
        },

        {
          id: 'hosp-radiology',
          title: 'Radiology',
          type: 'collapse',
          icon: 'fa fa-radiation-alt',
          children: [
            {
              id: 'radiology-xray-dashboard',
              title: 'X-Ray Dashboard',
              type: 'item',
              url: '/hospital/radiology/x-ray-dashboard',
            },
            {
              id: 'radiology-ultrasound-dashboard',
              title: 'Ultrasound Dashboard',
              type: 'item',
              url: '/hospital/radiology/ultrasound-dashboard',
            },
            {
              id: 'radiology-ct-dashboard',
              title: 'CT Dashboard',
              type: 'item',
              url: '/hospital/radiology/ct-dashboard',
            },
            {
              id: 'radiology-mri-dashboard',
              title: 'MRI Dashboard',
              type: 'item',
              url: '/hospital/radiology/mri-dashboard',
            },
            {
              id: 'radiology-mammography-dashboard',
              title: 'Mammography Dashboard',
              type: 'item',
              url: '/hospital/radiology/mammography-dashboard',
            },
          ],
        },
        {
          id: 'pathology',
          title: 'Pathology',
          type: 'item',
          url: '/hospital/hosp-pathology',
          icon: 'fa fa-cookie',
        },
        {
          id: 'blood-bank',
          title: 'Blood Bank',
          type: 'item',
          url: '/hospital/hosp-blood-bank',
          icon: 'fa fa-tint',
        },
        {
          id: 'hosp-er',
          title: 'ER',
          type: 'item',
          url: '/hospital/hosp-er',
          icon: 'fa fa-exclamation-triangle',
        },
        {
          id: 'hosp-surgery',
          title: 'Surgery',
          type: 'collapse',
          icon: 'fas fa-procedures',
          children: [
            {
              id: 'surgery-dashboard',
              title: 'Dashboard',
              type: 'item',
              url: '/hospital/hosp-surgery',
            },
            {
              id: 'surgery-waiting-suggestion-report',
              title: 'Waiting Suggestion',
              type: 'item',
              url: '/hospital/surgery-waiting-suggestion-report',
            },
          ],
        },
        {
          id: 'accident',
          title: 'Accident',
          type: 'item',
          icon: 'fa fa-user-injured ',
          url: '/patient/dashboard/analytics/88888',
          children: [
            {
              id: 'ipd-dashboard',
              title: 'Dashboard',
              type: 'item',
              url: '/hospital/hosp-finance',
            },
          ],
        },
        {
          id: 'ipd',
          title: 'IPD',
          type: 'collapse',
          icon: 'fas fa-procedures',
          children: [
            {
              id: 'ipd-dashboard',
              title: 'Dashboard',
              type: 'item',
              url: '/hospital/hosp-finance',
            },
            {
              id: 'ipd-waiting-room',
              title: 'Waiting Room',
              type: 'item',
              url: '/hospital/hosp-invoice',
            },
            {
              id: 'ipd-dc-record',
              title: 'D/C Record',
              type: 'item',
              url: '/hospital/ipd-dc',
            },
          ],
        },
        {
          id: 'hosp-finance',
          title: 'Finance',
          type: 'collapse',
          icon: 'fas fa-hand-holding-usd',
          children: [
            {
              id: 'finance-dashboard',
              title: 'Dashboard',
              type: 'item',
              url: '/hospital/hosp-finance',
            },
            {
              id: 'nhso-check-benefit',
              title: 'NHSO Check Benefit',
              type: 'item',
              url: '/hospital/nhso-check-benefit',
            },
            {
              id: 'nhso-close-benefit',
              title: 'NHSO Close Benefit',
              type: 'item',
              url: '/hospital/nhso-close-benefit',
            },

            {
              id: 'split-billing',
              title: 'Split Billing',
              type: 'item',
              url: '/hospital/hosp-split-billing',
            },
          ],
        },
        {
          id: 'hosp-dental',
          title: 'Dental',
          type: 'collapse',
          icon: 'ckd-icon ckd-dental',
          children: [
            {
              id: 'dental-dashboard',
              title: 'Dashboard',
              type: 'item',
              url: '/hospital/hosp-dental',
            },
          ],
        },
        {
          id: 'hosp-pharmacy',
          title: 'Pharmacy',
          type: 'collapse',
          icon: 'fa fa-prescription',
          children: [
            {
              id: 'med-dashboard',
              title: 'Dashboard',
              type: 'item',
              url: '/hospital/hosp-pharmacy',
            },
            {
              id: 'drug-cross-dashboard',
              title: 'Drug Cross',
              type: 'item',
              url: '/hospital/pharmacy/drug-cross-dashboard',
              icon: 'fa fa-shield-alt',
            },
            {
              id: 'med-restore',
              title: 'Restore',
              type: 'item',
              url: '/hospital/hosp-restore',
            },
            {
              id: 'med-error',
              title: 'Med Error',
              type: 'item',
              url: '/hospital/hosp-bed',
              icon: 'fa fa-pills',
            },
            {
              id: 'di',
              title: 'DI',
              type: 'item',
              url: '/hospital/hosp-bed',
              icon: 'fa fa-vials',
            },
          ],
        },
        {
          id: 'hosp-social-work',
          title: 'Social Work',
          type: 'collapse',
          icon: 'ckd-icon ckd-social-work',
          children: [
            {
              id: 'social-dashboard',
              title: 'Dashboard',
              type: 'item',
              url: '/hospital/social-work-dashboard',
            },
            {
              id: 'genogram',
              title: 'Genogram',
              type: 'item',
              url: '/hospital/hosp-genogram',
            },
          ],
        },
        {
          id: 'hosp-emar',
          title: 'eMar',
          type: 'item',
          url: '/hospital/hosp-emar',
          icon: 'fa fa-medkit',
        },
      ],
    },
    {
      id: 'hr',
      title: 'Human Resource',
      type: 'group',
      icon: 'fa fa-users',
      color: '#ed8395',
      children: [
        {
          id: 'hosp-employee',
          title: 'Employee',
          type: 'item',
          url: '/hr/hosp-doctor',
          icon: 'fa fa-user-md',
        },
        {
          id: 'hosp-time-off',
          title: 'Time off',
          type: 'item',
          url: '/hr/hosp-nurse',
          icon: 'fa fa-user-md',
        },
        {
          id: 'hr-payroll',
          title: 'Payroll',
          type: 'item',
          url: '/hr/payroll',
          icon: 'fa fa-money-bill',
        },
        {
          id: 'hr-salary',
          title: 'เงินเดือน',
          type: 'item',
          url: '/hr/salary',
          icon: 'fa fa-credit-card',
        },
        {
          id: 'hr-doctor-fee-dashboard',
          title: 'Doctor Fee Dashboard',
          type: 'item',
          url: '/hr/doctor-fee-dashboard',
          icon: 'fa fa-chart-bar',
        },
        {
          id: 'hr-payroll-item-config',
          title: 'ตั้งค่าเงินได้/เงินหัก',
          type: 'item',
          url: '/hr/payroll-item-config',
          icon: 'fa fa-cogs',
        },
        {
          id: 'hr-payroll-setting',
          title: 'ตั้งค่า Payroll',
          type: 'item',
          url: '/hr/payroll-setting',
          icon: 'fa fa-sliders-h',
        },
      ],
    },
    {
      id: 'stock',
      title: 'Stock',
      type: 'group',
      icon: 'feather icon-layers',
      url: '/stock/medical',
      color: '#4099ff',
      children: [
        {
          id: 'stock-medical',
          title: 'บัญชีเวชภัณฑ์',
          type: 'item',
          url: '/stock/medical',
          icon: 'ck-badge badge-primary',
          iconText: 'A',
          children: [],
        },
        {
          id: 'stock-company',
          title: 'บัญชีบริษัท',
          type: 'item',
          url: '/stock/company',
          icon: 'ck-badge badge-primary',
          iconText: 'B',
        },
        {
          id: 'stock-purchase-requisition',
          title: 'รายการใบขอซื้อ',
          type: 'item',
          url: '/stock/purchase-requisition',
          icon: 'ck-badge badge-primary',
          iconText: 'C',
        },
        {
          id: 'stock-purchase-order',
          title: 'รายการใบสั่งซื้อ',
          type: 'item',
          url: '/stock/purchase-order',
          icon: 'ck-badge badge-primary',
          iconText: 'D',
        },
        {
          id: 'stock-order-receipt',
          title: 'รายการรับของ',
          type: 'item',
          url: '/stock/order-receipt',
          icon: 'ck-badge badge-primary',
          iconText: 'E',
        },
        {
          id: 'stock-goods-issue',
          title: 'รายการเบิกจ่าย',
          type: 'item',
          url: '/stock/goods-issue',
          icon: 'ck-badge badge-primary',
          iconText: 'F',
        },
        {
          id: 'inventory-management',
          title: 'บริหารคลัง',
          type: 'item',
          url: '/stock/inventory-management',
          icon: 'ck-badge badge-primary',
          iconText: 'G',
        },
        {
          id: 'stock-taking',
          title: 'ปรับปรุงสต๊อกปิดงวด',
          type: 'item',
          url: '/stock/stock-taking',
          icon: 'ck-badge badge-primary',
          iconText: 'H',
        },
        {
          id: 'stock-budget',
          title: 'รายการงบประมาณ',
          type: 'item',
          url: '/stock/budget',
          icon: 'ck-badge badge-primary',
          iconText: 'I',
        },
        {
          id: 'stock-settings',
          title: 'การตั้งค่า',
          type: 'item',
          url: '/stock/settings',
          icon: 'ck-badge badge-primary',
          iconText: 'J',
        },
        {
          id: 'accounting-stock-settings',
          title: 'ตั้งค่าคลังบัญชี',
          type: 'item',
          url: '/accounting/stock-settings',
          icon: 'ck-badge badge-primary',
          iconText: 'K',
        },
      ],
    },
    {
      id: 'settings',
      title: 'Settings',
      type: 'group',
      icon: 'fa fa-cogs',
      color: '#FF5370',
      children: [
        {
          id: 'general-settings',
          title: 'General',
          type: 'item',
          url: '/settings/general',
          icon: 'feather icon-settings',
        },
        {
          id: 'stock-settings',
          title: 'Stock',
          type: 'item',
          url: '/stock/settings',
          icon: 'feather icon-settings',
        },
        {
          id: 'invoicing-settings',
          title: 'Invoicing',
          type: 'item',
          url: '/settings/invoicing',
          icon: 'feather icon-settings',
        },
        {
          id: 'document',
          title: 'Documents',
          type: 'item',
          url: '/settings/document',
          icon: 'feather icon-settings',
        },
        {
          id: 'opd',
          title: 'OPD',
          type: 'item',
          url: '/settings/opd',
          icon: 'feather icon-settings',
        },
        {
          id: 'doctor-fee',
          title: 'Doctor Fee',
          type: 'item',
          url: '/settings/doctor-fee',
          icon: 'feather icon-settings',
        },
        {
          id: 'device',
          title: 'Device',
          type: 'item',
          url: '/settings/device',
          icon: 'fa fa-desktop',
        },
        {
          id: 'printer',
          title: 'Printer',
          type: 'item',
          url: '/settings/printer',
          icon: 'fa fa-print',
        },
        {
          id: 'health-check-api',
          title: 'Health Check API',
          type: 'item',
          url: '/settings/health-check-api-page',
          classes: 'nav-item',
          icon: 'fa fa-info',
        },
        {
          id: 'about-page',
          title: 'About',
          type: 'item',
          url: '/settings/about-page',
          classes: 'nav-item',
          icon: 'fa fa-info',
        },
      ],
    },
    {
      id: 'menu',
      title: 'Dynamic Designer',
      type: 'group',
      icon: 'fa fa-toolbox',
      color: '#e38e14',
      children: [
        {
          id: 'module-designer-menu',
          title: 'Module Designer',
          type: 'item',
          url: '/designer/menu/module',
          classes: 'nav-item',
          icon: 'feather icon-grid',
          breadcrumbs: 'main',
          subBreadcrumbs: 'Form Layout',
        },
        {
          id: 'form-designer-menu',
          title: 'Form Designer',
          type: 'item',
          url: '/designer/menu/form',
          classes: 'nav-item',
          icon: 'feather icon-layout',
          breadcrumbs: 'main',
          subBreadcrumbs: 'Form Layout',
        },
        {
          id: 'page-designer-menu',
          title: 'Page Designer',
          type: 'item',
          url: '/designer/menu/page',
          classes: 'nav-item',
          icon: 'feather icon-layout',
          breadcrumbs: 'main',
          subBreadcrumbs: 'Page Layout',
        },
        {
          id: 'widget-designer-menu',
          title: 'Widget Designer',
          type: 'item',
          url: '/designer/menu/widget',
          classes: 'nav-item',
          icon: 'feather icon-layout',
          breadcrumbs: 'main',
          subBreadcrumbs: 'Widget Layout',
        },
        {
          id: 'dashboard-designer-menu',
          title: 'Dashboard Designer',
          type: 'item',
          url: '/designer/menu/dashboard',
          classes: 'nav-item',
          icon: 'feather icon-layout',
          breadcrumbs: 'main',
          subBreadcrumbs: 'Dashboard Layout',
        },
        {
          id: 'config-designer-menu',
          title: 'Menu Config',
          type: 'item',
          url: '/designer/menu/config',
          classes: 'nav-item',
          icon: 'feather icon-menu',
          breadcrumbs: 'main',
          subBreadcrumbs: 'Menu Config',
        },
        {
          id: 'form-assessment',
          title: 'Form Assessment',
          type: 'item',
          url: '/designer/menu/form-assessment',
          classes: 'nav-item',
          icon: 'feather icon-layout',
          breadcrumbs: 'main',
          subBreadcrumbs: 'Form Assessment',
        },
      ],
    },
    {
      id: 'ecommerce',
      title: 'Marketplace',
      type: 'group',
      icon: 'feather icon-shopping-cart',
      color: 'purple',
      children: [
        {
          id: 'ecomm-product',
          title: 'Product',
          type: 'item',
          url: '/ecommerce/ecomm-product',
          icon: 'feather icon-shopping-cart',
        },
        {
          id: 'ecomm-product-details',
          title: 'Product Details',
          type: 'item',
          url: '/ecommerce/ecomm-product-details',
          icon: 'feather icon-shopping-cart',
        },
        {
          id: 'ecomm-order',
          title: 'Order',
          type: 'item',
          url: '/ecommerce/ecomm-order',
          icon: 'feather icon-shopping-cart',
        },
        {
          id: 'ecomm-checkout',
          title: 'Checkout',
          type: 'item',
          url: '/ecommerce/ecomm-checkout',
          icon: 'feather icon-shopping-cart',
        },
        {
          id: 'ecomm-cart',
          title: 'Shopping Cart',
          type: 'item',
          url: '/ecommerce/ecomm-cart',
          icon: 'feather icon-shopping-cart',
        },
        {
          id: 'ecomm-customer',
          title: 'Customers',
          type: 'item',
          url: '/ecommerce/ecomm-customer',
          icon: 'fa fa-users',
        },
        {
          id: 'ecomm-seller',
          title: 'Sellers',
          type: 'item',
          url: '/ecommerce/ecomm-seller',
          icon: 'fa fa-users',
        },
      ],
    },
    {
      id: 'navigation',
      title: 'Navigation',
      type: 'group',
      icon: 'icon-navigation',
      children: [
        {
          id: 'dashboard',
          title: 'Dashboard',
          type: 'collapse',
          icon: 'feather icon-home',
          children: [
            {
              id: 'analytics',
              title: 'Analytics',
              type: 'item',
              url: '/app/dashboard/analytics',
              breadcrumbs: false,
            },
            {
              id: 'sales',
              title: 'Sales',
              type: 'item',
              url: '/app/dashboard/sales',
              badge: {
                title: 'NEW',
                type: 'badge-danger',
              },
            },
          ],
        },
        {
          id: 'layout',
          title: 'Page Layouts',
          type: 'collapse',
          icon: 'feather icon-layout',
          children: [
            {
              id: 'vertical',
              title: 'Vertical',
              type: 'collapse',
              children: [
                {
                  id: 'static',
                  title: 'Static',
                  type: 'item',
                  url: '/layout/vertical/static',
                  target: true,
                },
                {
                  id: 'fixed',
                  title: 'Fixed',
                  type: 'item',
                  url: '/layout/vertical/fixed',
                  target: true,
                },
                {
                  id: 'nav-fixed',
                  title: 'Navbar Fixed',
                  type: 'item',
                  url: '/layout/vertical/nav-fixed',
                  target: true,
                },
                {
                  id: 'collapse-menu',
                  title: 'Collapse Menu',
                  type: 'item',
                  url: '/layout/vertical/collapse-menu',
                  target: true,
                },
                {
                  id: 'v-rtl',
                  title: 'Vertical RTL',
                  type: 'item',
                  url: '/layout/vertical/v-rtl',
                  target: true,
                },
              ],
            },
            {
              id: 'horizontal',
              title: 'Horizontal',
              type: 'item',
              url: '/layout/horizontal',
              target: true,
            },
            {
              id: 'horizontal-v2',
              title: 'Horizontal v2',
              type: 'item',
              url: '/layout/horizontal-v2',
              target: true,
            },
            {
              id: 'horizontal-rtl',
              title: 'Horizontal RTL',
              type: 'item',
              url: '/layout/horizontal-rtl',
              target: true,
            },
            {
              id: 'box',
              title: 'Box Layout',
              type: 'item',
              url: '/layout/box',
              target: true,
            },
            {
              id: 'light',
              title: 'Light Layout',
              type: 'item',
              url: '/layout/light',
              target: true,
            },
            {
              id: 'dark',
              title: 'Dark Layout',
              type: 'item',
              url: '/layout/dark',
              target: true,
              badge: {
                title: 'Hot',
                type: 'badge-danger',
              },
            },
          ],
        },
        {
          id: 'widgets',
          title: 'Widget',
          type: 'collapse',
          icon: 'feather icon-layers',
          badge: {
            title: '100+',
            type: 'badge-info',
          },
          children: [
            {
              id: 'widget-statistic',
              title: 'Statistic',
              type: 'item',
              url: '/app/widgets/widget-statistic',
            },
            {
              id: 'widget-data',
              title: 'Data',
              type: 'item',
              url: '/app/widgets/widget-data',
            },
            {
              id: 'widget-chart',
              title: 'Chart',
              type: 'item',
              url: '/app/widgets/widget-chart',
            },
          ],
        },
        {
          id: 'users',
          title: 'Users',
          type: 'collapse',
          icon: 'feather icon-users',
          badge: {
            title: 'New',
            type: 'badge-warning',
          },
          children: [
            {
              id: 'user-profile',
              title: 'Profile',
              type: 'item',
              url: '/users/user-profile',
              breadcrumbs: false,
            },
            {
              id: 'user-cards',
              title: 'User Card',
              type: 'item',
              url: '/users/user-cards',
            },
            {
              id: 'user-list',
              title: 'User List',
              type: 'item',
              url: '/users/user-list',
            },
            {
              id: 'borrow-file',
              title: 'Borrow File',
              type: 'item',
              url: '/users/borrow-file',
            },
          ],
        },
      ],
    },
    {
      id: 'admin-panel',
      title: 'Admin Panel',
      type: 'group',
      icon: 'icon-monitor',
      children: [
        {
          id: 'hospital',
          title: 'Hospital',
          type: 'collapse',
          icon: 'feather icon-activity',
          children: [
            {
              id: 'hosp-dashboard',
              title: 'Dashboard',
              type: 'item',
              url: '/hospital/hosp-dashboard',
            },
            {
              id: 'opd-stage-report',
              title: 'OPD Stage Report',
              type: 'item',
              url: '/hospital/opd-stage-report',
            },
            {
              id: 'hosp-department',
              title: 'Department',
              type: 'item',
              url: '/hospital/hosp-department',
            },
            {
              id: 'user-list',
              title: 'User List',
              type: 'item',
              url: '/users/user-list',
            },
            {
              id: 'hosp-doctor',
              title: 'Doctor',
              type: 'item',
              url: '/hospital/hosp-doctor',
            },
            {
              id: 'hosp-nurse',
              title: 'Nurse',
              type: 'item',
              url: '/hospital/hosp-nurse',
            },
            {
              id: 'hosp-pharmacist',
              title: 'Pharmacist',
              type: 'item',
              url: '/hospital/hosp-pharmacist',
            },
            {
              id: 'hosp-laboratory',
              title: 'Laboratory',
              type: 'item',
              url: '/hospital/hosp-laboratory',
            },
            {
              id: 'hosp-appointment',
              title: 'Appointment',
              type: 'collapse',
              children: [
                {
                  id: 'appointment-dashboard',
                  title: 'Dashboard',
                  type: 'item',
                  url: '/hospital/hosp-appointment',
                },
                {
                  id: 'appointment-calendar',
                  title: 'Calendar',
                  type: 'item',
                  url: '/hospital/hosp-appointment-calendar',
                },
              ],
            },
            {
              id: 'hosp-ward',
              title: 'Ward View',
              type: 'item',
              url: '/hospital/hosp-ward',
            },
            {
              id: 'hosp-bed',
              title: 'Bed Calendar View',
              type: 'item',
              url: '/hospital/hosp-bed',
            },
            {
              id: 'hosp-queue',
              title: 'Queue',
              type: 'collapse',
              children: [
                {
                  id: 'queue-dashboard',
                  title: 'Dashboard',
                  type: 'item',
                  url: '/hospital/hosp-queue-dashboard',
                },
                {
                  id: 'queue-discharge',
                  title: 'Discharge',
                  type: 'item',
                  url: '/hospital/hosp-queue-discharge',
                },
                {
                  id: 'queue-call',
                  title: 'Call',
                  type: 'item',
                  url: '/hospital/hosp-queue-call',
                },
              ],
            },
            {
              id: 'hosp-pharmacy',
              title: 'Pharmacy',
              type: 'collapse',
              children: [
                {
                  id: 'med-dashboard',
                  title: 'Dashboard',
                  type: 'item',
                  url: '/hospital/hosp-pharmacy',
                },
                {
                  id: 'drug-cross-dashboard',
                  title: 'Drug Cross',
                  type: 'item',
                  url: '/hospital/pharmacy/drug-cross-dashboard',
                  icon: 'fa fa-shield-alt',
                },

                {
                  id: 'med-restore',
                  title: 'Restore',
                  type: 'item',
                  url: '/hospital/hosp-restore',
                },
              ],
            },
            {
              id: 'hosp-social-work',
              title: 'Social Work',
              type: 'collapse',
              children: [
                {
                  id: 'social-dashboard',
                  title: 'Dashboard',
                  type: 'item',
                  url: '/hospital/social-work-dashboard',
                },
                {
                  id: 'genogram',
                  title: 'Genogram',
                  type: 'item',
                  url: '/hospital/hosp-genogram',
                },
              ],
            },
            {
              id: 'hosp-finance',
              title: 'Finance',
              type: 'collapse',
              children: [
                {
                  id: 'finance-dashboard',
                  title: 'Dashboard',
                  type: 'item',
                  url: '/hospital/hosp-finance',
                },
                {
                  id: 'finance-debt-dashboard',
                  title: 'รับชำระหนี้ผู้ป่วย',
                  type: 'item',
                  url: '/hospital/finance/finance-debt-dashboard',
                },
                {
                  id: 'cash-management',
                  title: 'Cash Management',
                  type: 'collapse',
                  children: [
                    { id: 'cash-overview', title: 'Dashboard เงินสด', type: 'item', url: '/hospital/finance/cash-management' },
                    { id: 'cash-drawers', title: 'จัดการลิ้นชักเงินสด', type: 'item', url: '/hospital/finance/cash-management/drawers' },
                    { id: 'cash-shifts', title: 'ประวัติกะ', type: 'item', url: '/hospital/finance/cash-management/shifts' },
                    { id: 'cash-transactions', title: 'รายการเคลื่อนไหวเงินสด', type: 'item', url: '/hospital/finance/cash-management/transactions' },
                    { id: 'cash-transfers', title: 'ส่งมอบ/โอนลิ้นชัก', type: 'item', url: '/hospital/finance/cash-management/transfers' },
                    { id: 'cash-reports', title: 'รายงาน', type: 'item', url: '/hospital/finance/cash-management/reports' },
                  ],
                },
                {
                  id: 'nhso-check-benefit',
                  title: 'NHSO Check Benefit',
                  type: 'item',
                  url: '/hospital/nhso-check-benefit',
                },
                {
                  id: 'nhso-close-benefit',
                  title: 'NHSO Close Benefit',
                  type: 'item',
                  url: '/hospital/nhso-close-benefit',
                },
                {
                  id: 'split-billing',
                  title: 'Split Billing',
                  type: 'item',
                  url: '/hospital/hosp-split-billing',
                },
              ],
            },
            {
              id: 'hosp-dental',
              title: 'Dental',
              type: 'collapse',
              children: [
                {
                  id: 'dental-dashboard',
                  title: 'Dashboard',
                  type: 'item',
                  url: '/hospital/hosp-dental',
                },
              ],
            },
          ],
        },
        {
          id: 'settings',
          title: 'Settings',
          type: 'collapse',
          icon: 'feather icon-settings',
          children: [
            {
              id: 'doctor-fee',
              title: 'Doctor Fee',
              type: 'item',
              url: '/settings/doctor-fee',
            },
          ],
        },
        {
          id: 'helpdesk',
          title: 'Helpdesk',
          type: 'collapse',
          icon: 'feather icon-help-circle',
          children: [
            {
              id: 'hd-dashboard',
              title: 'Dashboard',
              type: 'item',
              url: '/helpdesk/hd-dashboard',
            },
            {
              id: 'hd-ticket',
              title: 'Create Ticket',
              type: 'item',
              url: '/helpdesk/hd-ticket',
            },
            {
              id: 'hd-ticket-list',
              title: 'Ticket List',
              type: 'item',
              url: '/helpdesk/hd-ticket-list',
            },
            {
              id: 'hd-ticket-details',
              title: 'Ticket Detail',
              type: 'item',
              url: '/helpdesk/hd-ticket-details',
            },
            {
              id: 'hd-customer-list',
              title: 'Customer',
              type: 'item',
              url: '/helpdesk/hd-customer-list',
            },
          ],
        },
        {
          id: 'project-crm',
          title: 'Project & CRM',
          type: 'collapse',
          icon: 'feather icon-package',
          children: [
            {
              id: 'pc-dashboard',
              title: 'Dashboard',
              type: 'item',
              url: '/project-crm/pc-dashboard',
            },
            {
              id: 'pc-customers',
              title: 'Customers',
              type: 'item',
              url: '/project-crm/pc-customers',
            },
            {
              id: 'pc-project',
              title: 'Project',
              type: 'item',
              url: '/project-crm/pc-project',
            },
            {
              id: 'pc-task',
              title: 'Task',
              type: 'item',
              url: '/project-crm/pc-task',
            },
          ],
        },
        {
          id: 'membership',
          title: 'Membership',
          type: 'collapse',
          icon: 'feather icon-user-check',
          children: [
            {
              id: 'mshp-dashboard',
              title: 'Dashboard',
              type: 'item',
              url: '/membership/mshp-dashboard',
            },
            {
              id: 'mshp-email',
              title: 'Email Templates',
              type: 'item',
              url: '/membership/mshp-email',
            },
            {
              id: 'mshp-country',
              title: 'Country',
              type: 'item',
              url: '/membership/mshp-country',
            },
            {
              id: 'mshp-coupons',
              title: 'Coupons',
              type: 'item',
              url: '/membership/mshp-coupons',
            },
            {
              id: 'mshp-newsletter',
              title: 'Newsletter',
              type: 'item',
              url: '/membership/mshp-newsletter',
            },
            {
              id: 'mshp-user',
              title: 'User',
              type: 'item',
              url: '/membership/mshp-user',
            },
            {
              id: 'mshp-membership',
              title: 'Membership',
              type: 'item',
              url: '/membership/mshp-membership',
            },
          ],
        },
        {
          id: 'school',
          title: 'School',
          type: 'collapse',
          icon: 'feather icon-book',
          badge: {
            title: 'New',
            type: 'badge-success',
          },
          children: [
            {
              id: 'sch-dashboard',
              title: 'Dashboard',
              type: 'item',
              url: '/school/sch-dashboard',
            },
            {
              id: 'sch-student',
              title: 'Student',
              type: 'item',
              url: '/school/sch-student',
            },
            {
              id: 'sch-parents',
              title: 'Parents',
              type: 'item',
              url: '/school/sch-parents',
            },
            {
              id: 'sch-teacher',
              title: 'Teacher',
              type: 'item',
              url: '/school/sch-teacher',
            },
          ],
        },
        {
          id: 'sis',
          title: 'SIS',
          type: 'collapse',
          icon: 'feather icon-book',
          children: [
            {
              id: 'sis-dashboard',
              title: 'Dashboard',
              type: 'item',
              url: '/sis/sis-dashboard',
            },
            {
              id: 'sis-leave',
              title: 'Leave',
              type: 'item',
              url: '/sis/sis-leave',
            },
            {
              id: 'sis-evaluation',
              title: 'Evaluation',
              type: 'item',
              url: '/sis/sis-evaluation',
            },
            {
              id: 'sis-event',
              title: 'Event',
              type: 'item',
              url: '/sis/sis-event',
            },
            {
              id: 'sis-circular',
              title: 'Circular',
              type: 'item',
              url: '/sis/sis-circular',
            },
            {
              id: 'sis-course',
              title: 'Course',
              type: 'item',
              url: '/sis/sis-course',
            },
          ],
        },
        {
          id: 'crypto',
          title: 'Crypto',
          type: 'collapse',
          icon: 'feather icon-target',
          children: [
            {
              id: 'cp-dashboard',
              title: 'Dashboard',
              type: 'item',
              url: '/crypto/cp-dashboard',
            },
            {
              id: 'cp-exchange',
              title: 'Exchange',
              type: 'item',
              url: '/crypto/cp-exchange',
            },
            {
              id: 'cp-wallet',
              title: 'Wallet',
              type: 'item',
              url: '/crypto/cp-wallet',
            },
            {
              id: 'cp-transactions',
              title: 'Transactions',
              type: 'item',
              url: '/crypto/cp-transactions',
            },
            {
              id: 'cp-history',
              title: 'History',
              type: 'item',
              url: '/crypto/cp-history',
            },
            {
              id: 'cp-trading',
              title: 'Trading',
              type: 'item',
              url: '/crypto/cp-trading',
            },
            {
              id: 'cp-coin',
              title: 'Initial Coin',
              type: 'item',
              url: '/crypto/cp-coin',
            },
            {
              id: 'cp-ico',
              title: 'Ico Listing',
              type: 'item',
              url: '/crypto/cp-ico',
            },
          ],
        },
      ],
    },
    {
      id: 'ckd-bench',
      title: 'ทดสอบระบบ',
      type: 'group',
      icon: 'fa fa-flask',
      color: 'grey',
      children: [
        {
          id: 'desktop-print-test',
          title: 'ทดสอบพิมพ์ผ่านโปรแกรม',
          type: 'item',
          url: '/hospital/hosp-desktop-print-test',
          icon: 'fa fa-print',
        },
      ],
    },
    {
      id: 'ui-element',
      title: 'UI ELEMENT',
      type: 'group',
      icon: 'icon-ui',
      children: [
        {
          id: 'basic',
          title: 'Basic',
          type: 'collapse',
          icon: 'feather icon-box',
          children: [
            {
              id: 'alert',
              title: 'Alert',
              type: 'item',
              url: '/basic/alert',
            },
            {
              id: 'button',
              title: 'Button',
              type: 'item',
              url: '/basic/button',
            },
            {
              id: 'badges',
              title: 'Badges',
              type: 'item',
              url: '/basic/badges',
            },
            {
              id: 'breadcrumb-pagination',
              title: 'Breadcrumb & Pagination',
              type: 'item',
              url: '/basic/breadcrumb-pagination',
            },
            {
              id: 'cards',
              title: 'Cards',
              type: 'item',
              url: '/basic/cards',
            },
            {
              id: 'collapse',
              title: 'Collapse',
              type: 'item',
              url: '/basic/collapse',
            },
            {
              id: 'carousel',
              title: 'Carousel',
              type: 'item',
              url: '/basic/carousel',
            },
            {
              id: 'grid-system',
              title: 'Grid System',
              type: 'item',
              url: '/basic/grid-system',
            },
            {
              id: 'progress',
              title: 'Progress',
              type: 'item',
              url: '/basic/progress',
            },
            {
              id: 'modal',
              title: 'Modal',
              type: 'item',
              url: '/basic/modal',
            },
            {
              id: 'spinner',
              title: 'Spinner',
              type: 'item',
              url: '/basic/spinner',
              badge: {
                title: 'New',
                type: 'badge-danger',
              },
            },
            {
              id: 'tabs-pills',
              title: 'Tabs & Pills',
              type: 'item',
              url: '/basic/tabs-pills',
            },
            {
              id: 'typography',
              title: 'Typography',
              type: 'item',
              url: '/basic/typography',
            },
            {
              id: 'tooltip-popovers',
              title: 'Tooltip & Popovers',
              type: 'item',
              url: '/basic/tooltip-popovers',
            },
            {
              id: 'other',
              title: 'Other',
              type: 'item',
              url: '/basic/other',
            },
          ],
        },
        {
          id: 'advance',
          title: 'Advance',
          type: 'collapse',
          icon: 'feather icon-gitlab',
          children: [
            {
              id: 'sweet-alert',
              title: 'Sweet Alert',
              type: 'item',
              url: '/advance/sweet-alert',
            },
            {
              id: 'datepicker',
              title: 'Datepicker',
              type: 'item',
              url: '/advance/datepicker',
            },
            {
              id: 'task-board',
              title: 'Task Board',
              type: 'item',
              url: '/advance/task-board',
            },
            {
              id: 'light-box',
              title: 'Light Box',
              type: 'item',
              url: '/advance/light-box',
            },
            {
              id: 'adv-modal',
              title: 'Modal',
              type: 'item',
              url: '/advance/adv-modal',
            },
            {
              id: 'notification',
              title: 'Notification',
              type: 'item',
              url: '/advance/notification',
            },
            {
              id: 'nestable',
              title: 'Nestable',
              type: 'item',
              url: '/advance/nestable',
            },
            {
              id: 'p-notify',
              title: 'P-Notify',
              type: 'item',
              url: '/advance/p-notify',
            },
            {
              id: 'rating',
              title: 'Rating',
              type: 'item',
              url: '/advance/rating',
            },
            {
              id: 'range-slider',
              title: 'Range Slider',
              type: 'item',
              url: '/advance/range-slider',
            },
            {
              id: 'slider',
              title: 'Slider',
              type: 'item',
              url: '/advance/slider',
            },
            {
              id: 'syntax-highlighter',
              title: 'Syntax Highlighter',
              type: 'item',
              url: '/advance/syntax-highlighter',
            },
            {
              id: 'tour',
              title: 'Tour',
              type: 'item',
              url: '/advance/tour',
            },
            {
              id: 'tree-view',
              title: 'Tree View',
              type: 'item',
              url: '/advance/tree-view',
            },
          ],
        },
      ],
    },
    {
      id: 'ui-forms',
      title: 'Forms',
      type: 'group',
      icon: 'icon-group',
      children: [
        {
          id: 'forms',
          title: 'Forms',
          type: 'collapse',
          icon: 'feather icon-file-text',
          children: [
            {
              id: 'form-basic',
              title: 'Form Elements',
              type: 'item',
              url: '/forms/form-basic',
            },
            {
              id: 'form-advance',
              title: 'Form Advance',
              type: 'item',
              url: '/forms/form-advance',
            },
            {
              id: 'form-validation',
              title: 'Form Validation',
              type: 'item',
              url: '/forms/form-validation',
            },
            {
              id: 'form-masking',
              title: 'Form Masking',
              type: 'item',
              url: '/forms/form-masking',
            },
            {
              id: 'form-wizard',
              title: 'Form Wizard',
              type: 'item',
              url: '/forms/form-wizard',
            },
            {
              id: 'form-picker',
              title: 'Form Picker',
              type: 'item',
              url: '/forms/form-picker',
            },
            {
              id: 'form-select',
              title: 'Form Select',
              type: 'item',
              url: '/forms/form-select',
            },
          ],
        },
      ],
    },
    {
      id: 'table',
      title: 'Table',
      type: 'group',
      icon: 'icon-table',
      children: [
        {
          id: 'tables',
          title: 'Table',
          type: 'collapse',
          icon: 'feather icon-server',
          children: [
            {
              id: 'bootstrap',
              title: 'Bootstrap Table',
              type: 'item',
              url: '/tables/bootstrap',
            },
            {
              id: 'datatable',
              title: 'React Tables',
              type: 'collapse',
              children: [
                {
                  id: 'tbl-basic',
                  title: 'Basic',
                  type: 'item',
                  url: '/table/datatable/tbl-basic',
                },
                {
                  id: 'tbl-footer',
                  title: 'Table Footer',
                  type: 'item',
                  url: '/table/datatable/tbl-footer',
                },
                {
                  id: 'tbl-sorting',
                  title: 'Sorting',
                  type: 'item',
                  url: '/table/datatable/tbl-sorting',
                },
                {
                  id: 'tbl-filtering',
                  title: 'Filtering',
                  type: 'item',
                  url: '/table/datatable/tbl-filtering',
                },
                {
                  id: 'tbl-grouping',
                  title: 'Grouping',
                  type: 'item',
                  url: '/table/datatable/tbl-grouping',
                },
                {
                  id: 'tbl-pagination',
                  title: 'Pagination',
                  type: 'item',
                  url: '/table/datatable/tbl-pagination',
                },
              ],
            },
          ],
        },
      ],
    },
    {
      id: 'chart-maps',
      title: 'Chart & Maps',
      type: 'group',
      icon: 'icon-charts',
      children: [
        {
          id: 'charts',
          title: 'Charts',
          type: 'collapse',
          icon: 'feather icon-pie-chart',
          children: [
            {
              id: 'apex-chart',
              title: 'Apex Chart',
              type: 'item',
              url: '/charts/apex-chart',
            },
            {
              id: 'chart-js',
              title: 'Chart JS',
              type: 'item',
              url: '/charts/chart-js',
            },
            {
              id: 'highchart',
              title: 'Highchart',
              type: 'item',
              url: '/charts/highchart',
            },
            {
              id: 'rechart',
              title: 'Rechart',
              type: 'item',
              url: '/charts/rechart',
            },
          ],
        },
        {
          id: 'maps',
          title: 'Maps',
          type: 'collapse',
          icon: 'feather icon-map',
          children: [
            {
              id: 'google-map',
              title: 'Google',
              type: 'item',
              url: '/maps/google-map',
            },
            {
              id: 'vector-map',
              title: 'Vector',
              type: 'item',
              url: '/maps/vector-map',
            },
          ],
        },
      ],
    },
    {
      id: 'pages',
      title: 'Pages',
      type: 'group',
      icon: 'icon-pages',
      children: [
        {
          id: 'auth',
          title: 'Authentication',
          type: 'collapse',
          icon: 'feather icon-lock',
          children: [
            {
              id: 'signup-1',
              title: 'Sign up',
              type: 'item',
              url: '/auth/signup-1',
              target: true,
              breadcrumbs: false,
            },
            {
              id: 'signup-2',
              title: 'Sign up v2',
              type: 'item',
              url: '/auth/signup-2',
              target: true,
              breadcrumbs: false,
            },
            {
              id: 'signin-1',
              title: 'Sign in',
              type: 'item',
              url: '/auth/signin-1',
              target: true,
              breadcrumbs: false,
            },
            {
              id: 'signin-2',
              title: 'Sign in v2',
              type: 'item',
              url: '/auth/signin-2',
              target: true,
              breadcrumbs: false,
            },
            {
              id: 'reset-password-1',
              title: 'Reset Password',
              type: 'item',
              url: '/auth/reset-password-1',
              target: true,
              breadcrumbs: false,
            },
            {
              id: 'reset-password-2',
              title: 'Reset Password v2',
              type: 'item',
              url: '/auth/reset-password-2',
              target: true,
              breadcrumbs: false,
            },
            {
              id: 'change-password',
              title: 'Change Password',
              type: 'item',
              url: '/auth/change-password',
              target: true,
              breadcrumbs: false,
            },
            {
              id: 'profile-settings',
              title: 'Profile Settings',
              type: 'item',
              url: '/auth/profile-settings',
              target: true,
              breadcrumbs: false,
            },
            {
              id: 'tabs-auth',
              title: 'Tabs Authentication',
              type: 'item',
              url: '/auth/tabs-auth',
              target: true,
              breadcrumbs: false,
            },
          ],
        },
        {
          id: 'maintenance',
          title: 'Maintenance',
          type: 'collapse',
          icon: 'feather icon-sliders',
          children: [
            {
              id: 'error',
              title: 'Error',
              type: 'item',
              url: '/maintenance/error',
              target: true,
              breadcrumbs: false,
            },
            {
              id: 'coming-soon',
              title: 'Coming Soon',
              type: 'item',
              url: '/maintenance/coming-soon',
              target: true,
              breadcrumbs: false,
            },
            {
              id: 'offline-ui',
              title: 'Offline UI',
              type: 'item',
              url: '/maintenance/offline-ui',
              target: true,
              breadcrumbs: false,
            },
          ],
        },
      ],
    },
    {
      id: 'app',
      title: 'App',
      type: 'group',
      icon: 'icon-app',
      children: [
        {
          id: 'task',
          title: 'Task',
          type: 'collapse',
          icon: 'feather icon-clipboard',
          children: [
            {
              id: 'task-list',
              title: 'Task List',
              type: 'item',
              url: '/task/task-list',
            },
            {
              id: 'task-board',
              title: 'Task Board',
              type: 'item',
              url: '/task/task-board',
            },
            {
              id: 'task-detail',
              title: 'Task Detail',
              type: 'item',
              url: '/task/task-detail',
            },
          ],
        },
        {
          id: 'to-dos',
          title: 'Todo',
          type: 'collapse',
          icon: 'feather icon-check-square',
          children: [
            {
              id: 'todo',
              title: 'Todo',
              type: 'item',
              url: '/todo/todo-basic',
            },
          ],
        },
        {
          id: 'gallery',
          title: 'Gallery',
          type: 'collapse',
          icon: 'feather icon-image',
          children: [
            {
              id: 'grid',
              title: 'Grid',
              type: 'item',
              url: '/gallery/gallery-grid',
            },
            {
              id: 'photo-grid',
              title: 'Photo Gallery',
              type: 'item',
              url: '/gallery/photo-grid',
            },
            {
              id: 'masonry',
              title: 'Masonry',
              type: 'item',
              url: '/gallery/gallery-masonry',
            },
          ],
        },
      ],
    },
    {
      id: 'extension',
      title: 'Extension',
      type: 'group',
      icon: 'icon-extension',
      children: [
        {
          id: 'editor',
          title: 'Editor',
          type: 'collapse',
          icon: 'feather icon-file-plus',
          children: [
            {
              id: 'ck-editor',
              title: 'CK-Editor',
              type: 'collapse',
              children: [
                {
                  id: 'ck-classic',
                  title: 'Classic Editor',
                  type: 'item',
                  url: '/editor/ck-editor/ck-classic',
                },
                {
                  id: 'ck-balloon',
                  title: 'Balloon Editor',
                  type: 'item',
                  url: '/editor/ck-editor/ck-balloon',
                },
                {
                  id: 'ck-inline',
                  title: 'Inline Editor',
                  type: 'item',
                  url: '/editor/ck-editor/ck-inline',
                },
                {
                  id: 'ck-document',
                  title: 'Document Editor',
                  type: 'item',
                  url: '/editor/ck-editor/ck-document',
                },
              ],
            },
            {
              id: 'rich-editor',
              title: 'Rich Editor',
              type: 'item',
              url: '/editor/rich-editor',
            },
            {
              id: 'jodit-wysiwyg',
              title: 'Jodit WYSIWYG',
              type: 'item',
              url: '/editor/jodit-wysiwyg',
            },
          ],
        },
        {
          id: 'invoice',
          title: 'Invoice',
          type: 'collapse',
          icon: 'feather icon-file-minus',
          children: [
            {
              id: 'invoice-basic',
              title: 'Invoice Basic',
              type: 'item',
              url: '/invoice/invoice-basic',
            },
            {
              id: 'invoice-summary',
              title: 'Invoice Summary',
              type: 'item',
              url: '/invoice/invoice-summary',
            },
            {
              id: 'invoice-list',
              title: 'Invoice List',
              type: 'item',
              url: '/invoice/invoice-list',
            },
          ],
        },
        {
          id: 'full-calendar',
          title: 'Full Calendar',
          type: 'item',
          url: '/full-calendar',
          classes: 'nav-item',
          icon: 'feather icon-calendar',
        },
        {
          id: 'file-upload',
          title: 'File Upload',
          type: 'item',
          url: '/file-upload',
          classes: 'nav-item',
          icon: 'feather icon-upload-cloud',
        },
        {
          id: 'image-cropper',
          title: 'Image Cropper',
          type: 'item',
          url: '/image-cropper',
          classes: 'nav-item',
          icon: 'feather icon-image',
        },
      ],
    },
    {
      id: 'support',
      title: 'Support',
      type: 'group',
      icon: 'icon-support',
      children: [
        {
          id: 'menu-level',
          title: 'Menu Levels',
          type: 'collapse',
          icon: 'feather icon-menu',
          children: [
            {
              id: 'menu-level-1.1',
              title: 'Menu Level 1.1',
              type: 'item',
              url: '#!',
            },
            {
              id: 'menu-level-1.2',
              title: 'Menu Level 2.2',
              type: 'collapse',
              children: [
                {
                  id: 'menu-level-2.1',
                  title: 'Menu Level 2.1',
                  type: 'item',
                  url: '#',
                },
                {
                  id: 'menu-level-2.2',
                  title: 'Menu Level 2.2',
                  type: 'collapse',
                  children: [
                    {
                      id: 'menu-level-3.1',
                      title: 'Menu Level 3.1',
                      type: 'item',
                      url: '#',
                    },
                    {
                      id: 'menu-level-3.2',
                      title: 'Menu Level 3.2',
                      type: 'item',
                      url: '#',
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          id: 'disabled-menu',
          title: 'Disabled Menu',
          type: 'item',
          url: '#',
          classes: 'nav-item disabled',
          icon: 'feather icon-power',
        },
        {
          id: 'sample-page',
          title: 'Sample Page',
          type: 'item',
          url: '/sample-page',
          classes: 'nav-item',
          icon: 'feather icon-sidebar',
        },
      ],
    },
  ],
}

export default menuItems
